import {Mapper} from '@s-ui/domain'

export default class FromTechnicalDetailsPageDataToAdvertisingValueObjectMapper extends Mapper {
  constructor({config, valueObjectFactory, fromPageNameToConstantNamingPageName}) {
    super()

    this._config = config
    this._culture = this._config.get('DEFAULT_CULTURE')
    this._lang = this._config.get('URL_CULTURES_MAP')[this._culture]

    this._valueObjectFactory = valueObjectFactory
    this._fromPageNameToConstantNamingPageName = fromPageNameToConstantNamingPageName
  }

  map = ({make, model, bodyType, fuelType, pageName}) => {
    const trackingConfig = this._config.get('tracking')
    const constantNamingPageName = this._fromPageNameToConstantNamingPageName.map(pageName)
    const adsNamePage = trackingConfig[`ADS_NAME_PAGE_${constantNamingPageName}`]
    const eventName = trackingConfig[`${constantNamingPageName}_EVENT_NAME`]

    return this._valueObjectFactory({
      ads_name_page: adsNamePage,
      ...(bodyType && {car_body: bodyType}),
      ...(fuelType && {fuel: fuelType}),
      ...(make && {brand: make.name}),
      ...(make && {brand_id: make.id}),
      ...(model && {model: model.name}),
      ...(model && {model_id: model.id}),
      country_code: this._lang,
      event_name: eventName,
      site: this._config.get('ID')
    })
  }
}
